export default {
    creditCardApplicationUrlParamChange: '?endre=1',
    creditCardApplicationUrlParamBusiness: '&type=business',
    creditCardApplicationUrlParamGold: '&type=gold',
};
